import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingAddress = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.shippingAddress;

export const shippingAddress = setCalculationModeShippingAddress(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_SHIPPING_ADDRESS',
  ''
);
